<template>
  <div class="contact-form-component container-fluid">
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="form-group">
          <label>
            Email
          </label>
          <input type="email" v-model="contact.email" class="form-control" />
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-group">
          <label>
            Mail Marketing
          </label>
          <select v-model="contact.mail_marketing" class="form-control">
            <option value="true" selected>Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-group">
          <label>
            Celular
          </label>
          <input
            type="text"
            v-mask="'(##) #####-####'"
            v-model="contact.cellphone"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-group">
          <label>
            Telefone 1
          </label>
          <input type="text" v-model="contact.phone_1" v-mask="'(##) ####-####'" class="form-control" />
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-group">
          <label>Telefone 2</label>
          <input type="text" v-model="contact.phone_2" v-mask="'(##) ####-####'" class="form-control" />
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="form-group">
          <label>Fax</label>
          <input type="text" v-model="contact.fax" class="form-control" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact-form",
  props: {
    contact: {
      mail_marketing:String
    }
  },
  watch:{
  },
  mounted(){
    // console.log(this.contact);
    // if(this.contact.mail_marketing != null){
    //   this.contact.mail_marketing = this.contact.mail_marketing ? 1 : 0;
    // }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.contact-form-component {
  padding: 0 !important;
}
</style>